module.exports = __webpack_public_path__ + "static/media/logo.6f3092ab.png";